<template>
  <b-col sm="12" lg="4">
    <div class="animated fadeIn">
      <b-card>
        <div v-if="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <div class="container">
            <div class="outer">
              <img :src="userPic" class="img-circle" alt="fibernode.com" />
              <div class="inner">
                <UpdatePicture :userId="userId" @picChanged="changePic" />
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import UpdatePicture from "./UpdatePicture";

export default {
  name: "ProfilePicture",
  props: ["userId"],
  components: {
    UpdatePicture
  },
  data() {
    return {
      loading: true,
      userPic: "",
      fakeCache: 1
    };
  },
  methods: {
    changePic(value) {
      this.userPic = value + "?version=1" + this.fakeCache;
      // this.userPic =
      //   "http://localhost/tracker_private/images/users/profilePicture-10363" +
      //   "?version=1" +
      //   this.fakeCache;
      this.fakeCache++;
    }
  },
  mounted() {
    this.userPic = localStorage.getItem("atx_user_picture");
    this.loading = false;
  }
};
</script>

<style scoped>
.sk-double-bounce {
  height: 12px !important;
  width: 12px !important;
  line-height: 55px;
  margin: auto;
}
.card-body {
  min-height: 480px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container {
  display: block;
  margin: auto;
}
.outer {
  max-width: 30vh !important; /* any size */
  max-height: 30vh !important; /* any size */
  margin: auto;
  position: relative;
}
.inner {
  width: 7vh;
  height: 7vh;
  border-radius: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
